import ReactGA from 'react-ga'

export function initializeAdTracking() {
  const GAKey = process.env.NODE_ENV === 'development' ? null : 'UA-87248871-1'
  ReactGA.initialize(GAKey)
}

export function trackPageView(path) {
  ReactGA.pageview(path)
}